import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { TiltCard } from '../UI/TiltCard';

export const Hero = () => {
  const { t } = useLanguage();

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      window.scrollTo({
        top: elementRect - bodyRect - offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <header className="hero-section" id="hero-header-section">
      <div className="hero-grid-overlay" />
      <div className="hero-glow-blob blob-1" />
      <div className="hero-glow-blob blob-2" />

      <div className="hero-container">
        <motion.div 
          className="hero-text-col"
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <div className="hero-badge" id="hero-stable-version-badge">
            <span className="badge-pulse" />
            {t('hero.badge')}
          </div>
          
          <h1 className="hero-title" id="hero-main-title">
            {t('hero.title')}
          </h1>
          
          <p className="hero-subtitle" id="hero-main-subtitle">
            {t('hero.subtitle')}
          </p>

          <div className="hero-actions">
            <button 
              className="btn-primary" 
              onClick={() => handleScrollTo('pricing')}
              id="hero-cta-start-btn"
            >
              <i className="fas fa-play mr-2"></i>
              {t('hero.ctaStart')}
            </button>
            <button 
              className="btn-secondary" 
              onClick={() => handleScrollTo('pricing')}
              id="hero-cta-pricing-btn"
            >
              <i className="fas fa-tags mr-2"></i>
              {t('hero.ctaPricing')}
            </button>
          </div>
        </motion.div>

        <motion.div 
          className="hero-image-col"
          initial={{ opacity: 0, scale: 0.95, y: 25 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: 'easeOut' }}
        >
          <TiltCard className="hero-screenshot-card">
            <img 
              src="/images/tg_dashboard.png" 
              alt="Telegram Prime Dashboard Screenshot"
              className="hero-screenshot"
              id="hero-software-dashboard-img"
            />
            
            <div className="screenshot-floating-badge badge-tr" id="hero-online-badge">
              <span className="live-dot" /> Online: 1,420
            </div>
            
            {/* <div className="screenshot-floating-badge badge-bl" id="hero-api-badge">
              <i className="fas fa-rocket text-indigo"></i>
              <span>API v3.0 Enabled</span>
            </div> */}
          </TiltCard>
        </motion.div>
      </div>
    </header>
  );
};

export default Hero;
